<div role="tablist" class="aa-tabgroup" [ngClass]="customCls" [class.justified]="justified">
    <ng-container *ngFor="let tab of tabs">
        <div class="aa-tab" [class.disabled]="tab.disabled" [class.active]="tab.active">
            <div [style.height.px]="height" class="aa-tab-title" (click)="selectTab(tab);">
                {{tab.title}}<ng-template [ngTemplateOutlet]="tab.titleTpl?.templateRef"></ng-template>
            </div>
            <div class="aa-tab-border"></div>
        </div>
    </ng-container>
</div>
<div class="aa-tab-content">
    <ng-container *ngFor="let tab of tabs">
        <div role="tabpanel" [attr.aria-labelledby]="tab.id" id="{{tab.id}}-panel" *ngIf="tab.active">
            <ng-template [ngTemplateOutlet]="tab.contentTpl?.templateRef"></ng-template>
        </div>
    </ng-container>
</div>
